// src/user/components/HtmlNode.js
import React from 'react';
import ActionButton from './ActionButton';
import WorkflowStepInstruction from './WorkflowStepInstruction';

/**
 * HtmlNode renders allowlisted HTML content with action buttons.
 * Content is sanitized at render time (defense in depth with server-side sanitization on save).
 *
 * Props:
 *  - view: { id, graphic, heading, text, actions }
 *  - onNavigate: callback for navigation actions
 */
export default function HtmlNode({ view, onNavigate, closeTask, accessKey, taskId }) {
  const { heading, text, actions } = view;

  return (
    <div className="container mt-3" id={`node-content-${view.id}`}>
      <WorkflowStepInstruction
        graphic={view.graphic}
        heading={heading}
        text={text}
      />

      {(actions?.length > 0 || closeTask) && (
        <div className="row mt-4">
          {actions &&
            actions.map((action, index) => (
              <div key={index} className="col-12 mb-2">
                <ActionButton
                  action={action}
                  fromStepId={view.id}
                  actionIndex={index}
                  taskId={taskId}
                  accessKeyToken={accessKey}
                  onNavigate={(targetViewId) => onNavigate(targetViewId)}
                />
              </div>
            ))}
          {closeTask && (
            <div className="col-12 mb-2">
              <ActionButton
                isCloseTask
                taskId={closeTask.taskId}
                accessKeyToken={closeTask.accessKeyToken}
                onTaskClosed={closeTask.onTaskClosed}
                afterClosePath={closeTask.afterClosePath}
                disabled={closeTask.disabled}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
}
